export class ConfigurationInfo {
  franchiseEnable: boolean = false
  distributorEnable: boolean = false
  couponEnable: boolean = false
  client: string
  clientId: string
  operatorId: string
  isPlan: string
  thirdPartyEnabled: boolean = false

  constructor(data) {
    this.franchiseEnable = data.franchiseEnable ? data.franchiseEnable : false;
    this.distributorEnable = data.distributorEnable ? data.distributorEnable : false;
    this.couponEnable = data.couponEnable ? data.couponEnable : false;
    this.thirdPartyEnabled = data.thirdPartyEnabled ? data.thirdPartyEnabled : false;
    this.client = data.client;
    this.clientId = data.clientId;
    this.operatorId = data.operatorId;
    this.isPlan = data.isPlan;

  }
}

